// extracted by mini-css-extract-plugin
export var navbarBurger = "navbar-module--navbarBurger--3X0HL";
export var exploreSearch = "navbar-module--exploreSearch--xEWs2";